import * as types from './mutation-types'

export default {
  [types.SET_NAVIGATOR_TITLE] (state, title) {
    state.title = title
  },
  [types.SET_NAVIGATOR_LINKS] (state, links) {
    state.links = links
  },
  [types.SET_STATUS_FINEPLAY] (state, fineplay) {
    state.fineplay = fineplay
  },
  [types.TOOGLE_FINEPLAY_SCREEN_CHAT] (state, enableFineplay = null) {
    state.enableFineplay = enableFineplay === null ? !state.enableFineplay : enableFineplay
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/navigator/mutations.js